shvenergy.videoplayer = (function ($) {
	"use strict";

	function playvideo(url) {

		var frame = document.createElement("div");
		frame.setAttribute("class", "videoframe");

		var iframe = document.createElement("iframe");
		iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("allowfullscreen", "true");
        iframe.setAttribute("allow", "autoplay; fullscreen; accelerometer; encrypted-media; gyroscope; picture-in-picture");
		iframe.setAttribute("src", url);
		
		frame.appendChild(iframe);
        shvenergy.modal.showModal(frame);
    }

	return {
		playvideo: playvideo
	};

})(jQuery);